import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams, Link} from 'react-router-dom';
import PageBase from "../../../components/PageBase/index";
import Field from "../../../components/FieldGroup/Field/index";
import bullet from '../../../assets/title-bullet.png';
import * as fundActions from "../../../redux/Funds/actions";
import * as ROUTES from "../../../utils/routes";
import FieldGroup from "../../../components/FieldGroup";

import './EditFunds.scss';
import ObjectSummaryRow from "../../../components/ObjectSummaryRow";

const EditFunds = props => {
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();
	const params = useParams();
	const fund = useSelector(state => state.fund.funds?.find(f => f.Id === params.id));

	useEffect(() => {
		const load = async () => {
			if(fund == null) {
				dispatch(fundActions.loadFundById(params.id))
			}
		};
		load();
	}, [fund, params.id]);

	if(fund == null) {
		return <div/>;
	}

	const summary = [
		{ title: 'Funds Name', value: fund.Name, blue: true},
		{ title: 'Amount', value: fund.Amount__c},
		{ title: 'Category', value: fund.Category__c},
		{ title: 'Status', value: fund.Status__c},
		{ title: 'Type', value: fund.Fund__c},
		{ title: 'Due Date', value: fund.Due_Date__c}
	];

	return (
		<PageBase title="Fund"
		          removeMargins
		          bodyBg="#fff"
		          headerLinkText="All Funds"
		          headerLinkTarget={ROUTES.FUNDS}
		>
			<div className="edit-fund-title">
				<img src={bullet} style={{width: '24px', marginRight: '20px'}} />
				<span>{fund.Name}</span>
			</div>

			<ObjectSummaryRow data={summary} />

			<div style={{height: '100%', overflowY: 'auto', padding: '0 20px'}}>
				<FieldGroup title="Details" expandable expanded>
					<Field title="Fund Owner" highlight>{fund.Owner?.Name}</Field>
					<Field title="Fund Name">{fund.Name}</Field>

					<Field title="Account Name">{fund.Account_Name__r?.Name}</Field>
					<Field title="Unique Identifier">{fund.Unique_Identifier__c}</Field>

					<Field title="Fund Type">{fund.Fund__c}</Field>
					<Field title="Leading Cloud">{fund.Leading_Cloud__c}</Field>

					<Field title="Related Opportunity">{fund.Related_Opportunity__r?.Name}</Field>
					<Field title="Category">{fund.Category__c}</Field>

					<Field title="Amount">{fund.Amount__c}</Field>
					<Field title="Related Service">{fund.Related_Service__c}</Field>

					<Field title="Priority">{fund.Priority__c}</Field>
					<Field title="Currency">{fund.CurrencyIsoCode}</Field>

					<Field title="Due Date">{fund.Due_Date__c}</Field>
					<Field title="Status">{fund.Status__c}</Field>

					<Field title="Actual Close Date">{fund.Actual_Close_Date__c}</Field>
					<Field title="Description">{fund.Description__c}</Field>
				</FieldGroup>

				<FieldGroup title="Activity" expandable>
					<Field title="Next Step">{fund.Next_Step__c}</Field>
					<Field title="Next Step Date">{fund.Next_Step_Date__c}</Field>

					<Field title="Next Step POC">{fund.Next_Step_POC__r?.Name}</Field>
					<Field title="Next Step Owner">{fund.Next_Step_Owner__r?.Name}</Field>
				</FieldGroup>

				<FieldGroup title="System Information" expandable>
					<Field title="Created By">{fund.CreatedBy.Name}</Field>
					<Field title="Last Modified By">{fund.LastModifiedBy.Name}</Field>
				</FieldGroup>
			</div>
		</PageBase>
	)
};

export default EditFunds;
